
import { useState, createContext } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import "antd/dist/antd.min.css";
import './style.css'


import { createTheme } from '@mui/material';
import { ThemeProvider } from '@mui/material';
import { StyledEngineProvider } from '@mui/material';

import {defaults} from "chart.js"
import AppRoutes from './components/AppRoutes';

//Override MUI global settings
const theme = createTheme({
  typography: {
    fontFamily: 'Poppins',
  },
})

export const UserContext = createContext();


function App() {
  //SET DEFAULT FONT FOR CHART JS
  defaults.font.family = 'Poppins';
  const pageSize = 1000
  const page_size = 1000

  const userType = localStorage.getItem('userType');

  // FETCH CLIENT PROFILE
  const [clientProfile, setClientProfile] = useState(null);
 
  return (
    <UserContext.Provider value={{ pageSize, page_size, clientProfile, setClientProfile }}>
      <ThemeProvider theme={theme}>
        <StyledEngineProvider injectFirst>
          <AppRoutes />
        </StyledEngineProvider>
      </ThemeProvider>
    </UserContext.Provider>
    );
}

export default App;
